import React, { useState } from "react";
import "./create-release.scss"
import { Modal, Button, Form, Input } from "antd";

import { useSelector } from "react-redux";
import { useToast } from "../../../../../helpers/commonFunction";
import { Http } from "../../../../../helpers/axois";

import { UpdateWidget } from "./UpdateWidget";

import { ReactComponent as CloseIcon } from "../../../../../assets/svg/roundedCloseIcon.svg";
interface IProps {
  setVisible: any;
  visible: boolean;
  productId: string;
  versions: any;
}

export const CreateRelease: React.FC<IProps> = ({ visible, setVisible, productId, versions }) => {
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const [versionExist, setVersionExist] = useState<boolean>(false)
  const [updateWidget, setUpdateWidget] = useState<any>({
    versionTag: "",
    releaseNotes: "",
    objectUrl: ""
  });
  const { ErrorToast, SuccessToast } = useToast()

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const data = {
      ...updateWidget
    }
    const endpoint = `/orgs/${orgId}/store/products/${productId}/release`;
    Http.put(endpoint, data).subscribe((res) => {
      SuccessToast("version updated")
      setVisible(false);
    }, (e) => {
      ErrorToast(e.message)
    })
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setUpdateWidget((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSetState = (key: string, value: any, isArray = false) => {
    setUpdateWidget((prevState: any) => {
      let updatedValue = prevState[key];
      if (isArray) {
        updatedValue = [...updatedValue, value];
      }
      return {
        ...prevState,
        [key]: isArray ? updatedValue : value,
      };
    });
  };

  const handleOnBlur = () => {
    const existingVersion = versions.map((version: any) => version.version_tag).filter((el: string) => el)
    const version = existingVersion.includes(updateWidget.versionTag);
    setVersionExist(version)
  }

  const handleOnCancel = (): void => {
    setVisible(false);
  };

  return (
    <div>
      <Modal
        title="NEW VERSION"
        visible={visible}
        maskClosable={false}
        className="override-modal"
        style={{
          top: 200,
        }}
        width="700px"
        closeIcon={
          <CloseIcon
            data-test-id="close_icon"
            height="18px"
            width="18px"
            onClick={() => setVisible(false)}
          />
        }
        footer={[
          <div className="version-footer">
            <Button type="default" className="cancel" onClick={handleOnCancel}>
              Cancel
            </Button>
            <Button type="primary" className="submit" onClick={handleSubmit}>
              Create Version
            </Button>
          </div>,
        ]}
        maskStyle={{
          background: "#0000001",
        }}
      >
        <Form className="version-modal">
          <Form.Item label="Enter Version" className="col-md-12">
            <Input
              data-test-id="current_version"
              name="versionTag"
              value={updateWidget.versionTag}
              placeholder="Enter version"
              onChange={handleInputChange}
              onBlur={handleOnBlur}
            />
            {versionExist &&
              <div className="text-danger p-2 mt-3">Version already exists</div>
            }
          </Form.Item>
          <Form.Item label="Release Notes" className="col-md-12">
          <Input.TextArea
              data-test-id="release_notes"
              autoSize={{ minRows: 5 }}
              name="releaseNotes"
              placeholder="Enter Release Notes"
              value={updateWidget.releaseNotes}
              onChange={handleInputChange}
            />
          </Form.Item>
          <UpdateWidget setObjectUrl={handleSetState} orgId={orgId} />
        </Form>
      </Modal>
    </div>
  )
}
